import React from "react";
import './activity.css';
import activities from '../../activity.json'

function Activity(){
    return (
        <div id="activity" className="activity-container">
            <h1>نشاطات فريق الجودة</h1>
            <hr />
            <div className="activiy-list">
                {activities.map((activity)=>(
                    <div key={activity.id} className="activity-item">
                        <div className="activity-name-box"><h2>{activity.name}</h2></div>
                        <div className="pic-desc">
                            <div className="activity-pics-box"><img src={activity.picture1} alt="" /></div>
                            <div className="acitiviy-desc-box"><p>{activity.description}</p></div> 
                        </div>  
                    </div>
                ))}
            </div>
        </div>
    )
}

export default Activity;